var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"category-item"},[_c('div',{staticClass:"index-icon"},[_vm._t("icon")],2),_c('div',{staticClass:"index-head"},[_c('h2',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"subcategory-list"},[_vm._t("category-list")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }